<template>
  <div>
    <bd-table-list
      :breadcrumb="breadcrumb"
      title="Historique"
      subtitle="Recherche dans l'historique"
      autocomplete_idHistory="history"
      autocomplete_field="front_history.object || front_history.message"
      bdTable="front_history"
      defaultOrder="timestamp"
      :fields="fields"
      :Api="Api"
    >
      <template v-slot:cell(complete)="data">
        <b-link v-if="data.item.to"
          :to="{ name: data.item.to.name, params: data.item.to.params }"
        >
          {{ data.item.complete }}
        </b-link>
        <span v-else>
          {{ data.item.complete }}
        </span>
      </template>
    </bd-table-list>
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import front_history from "@/services/front_history.js";
export default {
  name: "FrontHistory",
  components: {
    BdTableList,
  },
  methods: {
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDateTime(d);
    },
  },
  data() {
    return {
      Api: front_history,
      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Historique",
          active: true,
        },
      ],
     
      fields: [
        
        {
          key: "timestamp",
          label: "Date",
          sortable: true,
           thStyle: "width:200px",
          formatter: (value) => {
            return this.toDate(value);
          },
        },
        {
          key: "nego",
          label: "Utilisateur",
          sortable: true,
        },
        {
          key: "complete",
          label: "Objet",
          sortable: true
        },
        {
          key: "message",
          label: "action",
          sortable: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>